// extracted by mini-css-extract-plugin
export default {"container":"layout_container__P0uls","rightTitle":"layout_rightTitle__cJ2EQ"};